<template>
    <q-header unelevated class="bg-white text-black" :style="bottomHide ? '' : 'border-bottom:1px solid #E0E0E0;'">
        <q-toolbar style="padding:0 2vw">
            <div class="row" style="width: 100%; height: 7.17vmin;">
                <div class="col-4 " style="display: flex; position: relative; align-items: center;height: 100%">
                    <q-icon name="img:/assets/images/icon/ico_back.svg" :onclick="onClickHome" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
                    <!-- <q-icon name="img:/assets/images/icon/ico_home.svg" :onclick="onClickHome" style="width: 2.4vw; height: 2.4vw; cursor: pointer" /> -->
                    <div class="header_lesson q-px-sm b1 medium">수능모의평가</div>
                </div>
                <div v-show="!timerEnable || scoreVisible" class="col-8" style="display: flex;align-items: center;justify-content: flex-end;;height: 100%">
                    <q-icon name="img:/assets/images/icon/ico_home.svg" :onclick="onClickHome" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
                </div>
                <div v-show="timerEnable && !scoreVisible" class="col-4"
                    style="text-align: center;display: flex;justify-content: center;;height: 100%">
                    <div v-show="!isPause" class="caption1 line_height_28"
                        style="display: inline-flex;align-items: center;">
                        풀이시간 <b class="h1 line_height_48 mg_left_16 color_gray_600"
                            :style="timerSec > limitTime ? 'color: #FF4E7C;' : ''">{{
                                    getTimeStringMilliseconds(timerSec)
                            }}</b>
                    </div>
                </div>
                <div v-show="timerEnable && !scoreVisible" class="col-4" style="display: flex;position: relative;align-items: center; ;height: 100%">
                    <div style="text-align: end; width: 100%;">
                        <q-btn outline class="btn"
                            :icon-right="`${isMenuOpen === true ? 'expand_less' : 'expand_more'}`" label="문항번호 보기">
                            <q-menu transition-show="jump-down" transition-hide="jump-up" anchor="bottom end"
                                self="top end" :offset="[0, 6]" @before-show="() => { isMenuOpen = true }"
                                @before-hide="() => { isMenuOpen = false }"
                                style="border:2px solid #8E8E8E;border-radius:1.33vmin; box-shadow: none;" max-width="78.16vmin">
                                <div class="header_nav">
                                    <div class="q-pb-sm b1 line_height_45">
                                        <b>문항 번호를 눌러 이동해보세요.</b>
                                    </div>
                                    <!-- <q-separator /> -->
                                    <div class="row">
                                        <template v-for="index in Object.keys(headerItems)">
                                            <div class="item-nomal" :style="index % 10 === 0 ? 'padding-right:0;' : ''">
                                                <!-- <div :class="[Number(index) > 9 ? (headerInfo[index]?.answer ? 'item-num1 checked' : 'item-num1') : (headerInfo[index]?.answer ? 'item-num checked' : 'item-num')]"
                                                        :onClick="() => { onClick(index) }"> -->
                                                <div :class="headerItems[index].classNm"
                                                    :onClick="() => { onClick(index) }">
                                                    {{ index }}
                                                </div>
                                                <!-- <div
                                                        style="justify-content:center;display: flex; text-align: center; margin-top: 5px;">
                                                        <div class="checked_small">
                                                            <q-icon v-if="true" name="radio_button_unchecked" size="1em"
                                                                class='checkedicon' />
                                                                <q-icon v-if="false" name="close" size="1em" class='checkedicon' />
                                                            </div>
                                                        </div> -->
                                            </div>
                                            <q-separator v-if="index % 10 === 0"
                                                style="height: 1px;padding: 0 1.17vmin; width:calc( 100% - 2.34vmin)" />
                                        </template>
                                    </div>

                                </div>
                            </q-menu>
                        </q-btn>
                    </div>
                </div>
            </div>
        </q-toolbar>
        <q-linear-progress v-if="!bottomHide && !isPause" :value="progress" style="color:#18b73f" size="3px" />
    </q-header>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue';
import { useRouter } from "vue-router";
import { DialogStore } from "@/store/modules/dialog";
import { StudyStore } from "@/store/modules/study";
import { headerEtcCd02, headerEtcCd01, studyTree } from "@/helpers/qbankParser/qbankMeta";
import { getTimeStringMilliseconds } from "@/helpers/utils"

const isMenuOpen = ref(false);
const timerSec = ref(0);
// const headerInfo = ref(0);
const problemOrder = ref(1);
const progress = ref(0);
const timerEnable = ref(false);
// const timerEnable = ref(true);
const headerItems = ref(null);
let secInterval = null;


const router = useRouter();
const store = DialogStore();
const studyStore = StudyStore();

const checkConfirm = (val) => {
    val && router.push('/learninghome');
}

const props = defineProps({
    'timerEnable': { default: false },
    'isPause': { default: true },
    'headerInfo': {},
    'problemOrder': {
        default: 1
    },
    'limitTime': {
        default: 3600000
    },
    'baseTime': {
        default: 0
    },
    'bottomHide': {
        default: false
    },
    'scoreVisible': {
        defualt: false
    }
}
);

const emit = defineEmits(['nextStep']);

const disableCheck = (passage, sTree) => {
    if (studyStore.process.examIdx < passage) {
        return true;
    } else {
        if (studyStore.process.studyTree < sTree) {
            return true;
        } else {
            return false;
        }
    }
}

const onClickHome = () => {
    store.openConfirmDialog({
        message: '수능 모의평가 진행중입니다.\n 홈으로 이동하시겠습니까?',
        cancel: '닫기',
        ok: '확인',
        callback: checkConfirm,
    });
}

const onClick = (num) => {
    if (props.headerInfo[num].completeYn || !props.headerInfo[num]?.result) {
        emit('nextStep', false, num);
    }
}

watch(() => props.timerEnable, (newValue) => {
    // clearInterval(secInterval);
    // if (newValue) {
    //     // todo: 기존 측정시간 timeKey 에 해당하는 store에 저장
    //     // oldV
    //     // timerSec.value = Number(newV.sec);
    //     secInterval = setInterval(() => { timerSec.value = (timerSec.value) + 1; }, 1000);
    // } else {

    // }
    timerEnable.value = newValue
});

watch(() => props.isPause, (newValue) => {
    if (newValue) {
        clearInterval(secInterval);
    } else {
        secInterval = setInterval(() => { timerSec.value = (timerSec.value) + 1000; }, 1000);
    }
});

watch(() => props.baseTime, (newValue) => {
    // console.log('!!!!!!! baseTime !!!!!!!!!!!!!');
    // console.log(newValue);
    // headerInfo.value = newValue;
    timerSec.value = timerSec.value + Number(newValue);
});

watch(() => props.headerInfo, (newValue) => {
    // console.log('!!!!!!! headerInfo !!!!!!!!!!!!!');
    // const newValue = p.headerInfo;
    // console.log(newValue);
    // headerInfo.value = newValue;
    let tmpH = {};
    if (newValue) {
        let cnt = 0;
        Object.entries(newValue).forEach(([k, v]) => {
            if (v?.answer !== null) {
                cnt += 1;
            }
            // v.classNm = getClassName(k);
            tmpH = { ...tmpH, [k]: { ...v, classNm: getClassName(v, k) } }
        });
        // console.log('header item:', tmpH)
        headerItems.value = tmpH;
        progress.value = cnt / 34;
        // console.log(progress.value);
    }
});

watch(() => props.problemOrder, (newValue) => {
    // console.log('!!!!!!!!!!!!!!!!!!!!');
    // console.log(newValue);
    problemOrder.value = newValue;
});

onMounted(() => {
    // console.log('score visible:', props.scoreVisible)
    // console.log('onMounted ~~!!!!');
    // console.log(props.sec);
    // timerSec.value = Number(props.sec);
    // secInterval = setInterval(() => { timerSec.value += 1; }, 1000);

})

onUnmounted(() => {
    secInterval && clearInterval(secInterval);
})

const getClassName = (item, num) => {
    // console.log(headerInfo);
    // const headerInfo = props.headerInfo;
    // console.log(headerInfo[num]);
    let rsName = 'item';
    if (item?.result) {
        rsName += ('-' + (item?.result?.marking === 'right' ? 'right' : 'wrong'));
        if (item?.completeYn) {
            rsName += ('-' + 'done');
        }
    } else {
        rsName += '-num';
        if (item?.answer) {
            rsName += (' ' + 'checked');
        }
        if (num === problemOrder.value) {
            rsName += (' ' + 'selected');
        }
    }
    return rsName;
}

const getClassName_old = (num) => {
    // console.log(headerInfo);
    const headerInfo = props.headerInfo;
    // console.log(headerInfo[num]);
    let rsName = 'item';
    if (headerInfo[num]?.result) {
        rsName += ('-' + (headerInfo[num]?.result?.marking === 'right' ? 'right' : 'wrong'));
        if (headerInfo[num]?.completeYn) {
            rsName += ('-' + 'done');
        }
    } else {
        rsName += '-num';
        if (headerInfo[num]?.answer) {
            rsName += (' ' + 'checked');
        }
        if (num === problemOrder.value) {
            rsName += (' ' + 'selected');
        }
    }
    return rsName;
}

</script>

<style scoped lang="scss">
.header {
    &_lesson {}

    &_nav {
        // padding: 20px;
        // width: 600px;
        padding: 3.75vmin 4.08vmin;
        width: 73vmin;
    }
}

::v-deep .item {
    &-nomal {
        // background-color: #efefef;
        // border-radius: 10px;
        display: grid;
        justify-content: center;
        align-items: center;
        padding: 2vmin 2vmin 2vmin 0;

        .item-num {
            border-radius: 50%;
            border: 2px solid #BDBDBD;
            color: #BDBDBD;
            background-color: #FAFAFA;
            width: 4.67vmin;
            height: 4.67vmin;
            text-align: center;
            cursor: pointer;
            font-size: 1.2vw;
            line-height: 1.5vw;
            font-weight: 500;
            display: inline-flex;
            align-items: center;
            justify-content: center;
        }

        .item-num1 {
            // padding: 0px 4px 2px;
            border-radius: 50%;
            border: 2px solid #BDBDBD;
            color: #BDBDBD;
            background-color: #FAFAFA;
            width: 4.67vmin;
            height: 4.67vmin;
            text-align: center;
            cursor: pointer;
            font-size: 1.2vw;
            line-height: 1.5vw;
            font-weight: 500;
            display: inline-flex;
            align-items: center;
            justify-content: center;
        }

        .item-right {
            // border: 2px solid #118AF1;
            // color: black;
            // font-weight: 500;
            // border-radius: 50%;
            // width: 25px;
            // height: 25px;
            // text-align: center;
            // cursor: not-allowed;

            border-radius: 50%;
            border: 2px solid #4659FF;
            color: black;
            background-color: #FAFAFA;
            width: 4.67vmin;
            height: 4.67vmin;
            text-align: center;
            cursor: not-allowed;
            font-size: 1.2vw;
            line-height: 1.5vw;
            font-weight: 500;
            display: inline-flex;
            align-items: center;
            justify-content: center;

            &-done {
                // font-weight: 500;
                // background-color: #118AF1;
                // color: white;
                // border-radius: 50%;
                // width: 25px;
                // height: 25px;
                // text-align: center;
                // cursor: pointer;

                border-radius: 50%;
                background-color: #4659FF;
                color: white;
                cursor: pointer;
                width: 4.67vmin;
                height: 4.67vmin;
                text-align: center;
                font-size: 1.2vw;
                line-height: 1.5vw;
                font-weight: 500;
                display: inline-flex;
                align-items: center;
                justify-content: center;
            }
        }

        .item-wrong {
            // background-image: url('@/assets/images/symbols/x.png');
            // background-size: 50%;
            // background-repeat: no-repeat;
            // background-position-x: center;
            // background-position-y: center;
            // border: 2px solid #EF2B2A;
            // color: black;
            // border-radius: 50%;
            // width: 25px;
            // height: 25px;
            // text-align: center;
            // cursor: not-allowed;

            background-image: url('@/assets/images/symbols/x.png');
            background-size: 50%;
            background-repeat: no-repeat;
            background-position-x: center;
            background-position-y: center;
            border: 2px solid #EF2B2A;
            color: black;
            border-radius: 50%;
            width: 25px;
            height: 25px;
            cursor: not-allowed;
            width: 4.67vmin;
            height: 4.67vmin;
            text-align: center;
            font-size: 1.2vw;
            line-height: 1.5vw;
            font-weight: 500;
            display: inline-flex;
            align-items: center;
            justify-content: center;

            &-done {
                // font-weight: 500;
                // background-color: #EF2B2A;
                // color: white;
                // border-radius: 50%;
                // width: 25px;
                // height: 25px;
                // text-align: center;
                // cursor: pointer;

                font-weight: 500;
                background-color: #EF2B2A;
                color: white;
                border-radius: 50%;
                width: 25px;
                height: 25px;
                cursor: pointer;
                width: 4.67vmin;
                height: 4.67vmin;
                text-align: center;
                font-size: 1.2vw;
                line-height: 1.5vw;
                font-weight: 500;
                display: inline-flex;
                align-items: center;
                justify-content: center;
            }
        }

        .checked {
            background-color: #BDBDBD;
            // background-color: #FAFAFA;
            color: white;
            cursor: pointer;
        }

        .selected {
            background-color: #000000;
            color: white;
            cursor: pointer;
        }

    }

    &-select {
        // background-color: #efefef;
        border-radius: 10px;

        .item-num {
            border-radius: 20px;
            border: 1px solid #BDBDBD;
            background-color: #BDBDBD;
            color: white;
            padding: 0px 8px 2px;
        }

        .item-num1 {
            border-radius: 20px;
            border: 1px solid #BDBDBD;
            background-color: #BDBDBD;
            color: white;
            padding: 0px 4px 2px;
        }
    }


    &-correct {
        // background-color: #d7eaff;
        border-radius: 10px;

        .item-num {
            border: 1px solid #4659FF;
            background-color:#4659FF;
            color: white;
            border-radius: 20px;
            padding: 0px 8px 2px;
        }

        .item-num1 {
            border: 1px solid #4659FF;
            background-color: #4659FF;
            color: white;
            border-radius: 20px;
            padding: 0px 4px 2px;
        }
    }

    &-wrong {
        // background-color: #ffc8d6;
        border-radius: 10px;

        .item-correct_num {
            border: 1px solid #fc6a8f;
            background-color: #fc6a8f;
            border-radius: 20px;
            padding: 0px 8px 2px;
        }

        .item-correct_num1 {
            border: 1px solid #fc6a8f;
            background-color: #fc6a8f;
            border-radius: 20px;
            padding: 0px 4px 2px;
        }
    }
}

.checked_small {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #bbbbbb60;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $primary;

    .checkedicon {
        color: #fff;
    }
}

.btn {
    font-size: 1.2vw; // 24px
    line-height: 1.6vw;
    border-radius: 1.33vmin;
    padding: 1.17vmin 1vmin 1.17vmin 2vmin;
    font-weight: 700;
    width: 12.4vw;
}
</style>
